export const parseCart = (data) => {
  const products = []
  data.lines.edges.forEach(({ node }) => {
    const title = node.attributes.find(({ key }) => {
      return key === 'title'
    })
    const color = node.attributes.find(({ key }) => {
      return key === 'color'
    })
    const size = node.attributes.find(({ key }) => {
      return key === 'size'
    })
    const image = node.attributes.find(({ key }) => {
      return key === 'image'
    })
    const handle = node.attributes.find(({ key }) => {
      return key === 'site_link'
    })
    let price = null
    let strikeoutPrice = null
    if (
      node.merchandise.compareAtPrice &&
      node.merchandise.compareAtPrice.amount
    )
      strikeoutPrice = node.merchandise.compareAtPrice.amount.toString()
    else strikeoutPrice = null
    price = node.merchandise.price.amount.toString()
    const isFinalSale = node.attributes.find(({ key }) => {
      return key === 'is_final_sale'
    })
    products.push({
      id: node.merchandise.id,
      quantity: node.quantity,
      title: title ? title.value : null,
      color: color ? color.value : null,
      size: size ? size.value : null,
      image: image ? image.value : null,
      handle: handle ? handle.value : null,
      price,
      strikeoutPrice,
      quantityAvailable: node.merchandise.quantityAvailable,
      sku: node.merchandise.sku,
      isFinalSale: isFinalSale ? isFinalSale.value : null,
    })
  })
  return {
    id: data.id,
    products,
    totalAmount: data.totalAmount ? data.totalAmount.amount.toString() : null,
    subtotalAmount: data.subtotalAmount
      ? data.subtotalAmount.amount.toString()
      : null,
    totalTaxAmount: data.totalTaxAmount
      ? data.totalTaxAmount.amount.toString()
      : null,
  }
}
